import { createState, useState as useGlobalState } from "@hookstate/core";

const initialState = {
  culture: "en-gb",
  cache: {},
};

const globalState = createState(initialState);
export default () => useGlobalState(globalState);
